import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    header: {
      "& .MuiTypography-body2": {
        fontSize: "1.1em !important"
      }
    },
    container: {
      position: "relative"
    },
    avatar: {
      backgroundColor: "#f09b0d"
    },
    spinnerContainer: {
      position: "absolute",
      backgroundColor: "rgba(255,255,255,0.8)",
      zIndex: 100,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  })
);
